import { IconCards } from "@tabler/icons-react";
import { type ComponentType, createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const GamesPage = lazy(() => import("./GamesPage").then((m) => ({ default: m.GamesPage })));
const GameDetailPage = lazy(() => import("./GameDetailPage").then((m) => ({ default: m.GameDetailPage })));
const BrandGamesPage = lazy(() => import("./BrandGamesGrid").then((m) => ({ default: m.BrandGamesPage })));

const el = <P extends object>(c: ComponentType<P>, props: P) =>
  createElement(Suspense, { fallback: null }, createElement(c, props));

export const routes: FeatureRoute[] = [
  { path: "/admin/games", roles: CAPS.admin.gamesRead, element: el(GamesPage, {}) },
  { path: "/admin/games/:slug", roles: CAPS.admin.gamesRead, element: el(GameDetailPage, {}) },
  // Under Partners (link from the Brands tab) so the nav highlights Partners; writes need game_admin.
  {
    path: "/admin/partners/:id/brands/:brandId/games",
    roles: CAPS.admin.gamesRead,
    element: el(BrandGamesPage, { surface: "admin" }),
  },
];

export const nav: NavItem[] = [
  { label: "Games", path: "/admin/games", icon: IconCards, surface: "admin", roles: CAPS.admin.gamesRead },
];
